module.exports = __webpack_public_path__ + "static/media/icon-macro-rest.d6d2337b.svg";